import { collection, addDoc } from "firebase/firestore";
import { db } from "../firebase/firebaseConfig";

const sendConfirmationEmail = async (email, firstName, uid, confirmationCode) => {
  const firestore = db;

  // Construct the URL for the button or hyperlink
  const confirmationUrl = `https://getfullproof.com/c/${uid}${confirmationCode}`;

  const message = {
    html: `
      <!DOCTYPE html>
      <html lang="en" xmlns="http://www.w3.org/1999/xhtml">
      <head>
        <meta charset="UTF-8" />
        <meta http-equiv="x-ua-compatible" content="ie=edge" />
        <title>Welcome to Fullproof</title>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <!-- 
          Minimal CSS reset and basic styling for email 
          Make sure to keep inline styles on anything 
          crucial for cross-client consistency.
        -->
        <style type="text/css">
          body {
            margin: 8px;
            padding: 0;
            background-color: #fff;
            font-family: Arial, sans-serif;
            -webkit-font-smoothing: antialiased;
            -webkit-text-size-adjust: none;
          }
          table {
            border-collapse: collapse;
          }
          a {
            text-decoration: none;
            color: inherit;
          }
        </style>
      </head>
      
      <body style="margin:0; padding:0; background-color:#ffffff;">
        <!-- Outer container table (full width) -->
        <table width="100%" cellspacing="0" cellpadding="0" border="0" style="background-color:#ffffff;">
          <tr>
            <td align="center">
              <!-- Inner container for all content, max-width 600px -->
              <table width="600" cellspacing="0" cellpadding="0" border="0" style="max-width:600px; width:100%; margin:0 auto;">
                
                <!-- Header / Logo row -->
                <tr>
                  <td align="center" style="padding: 20px 0 10px 0; ">
                    <img 
                      src="https://firebasestorage.googleapis.com/v0/b/fullproof-app.firebasestorage.app/o/Logos%2Ffullproof_logo_black.png?alt=media&token=bf0aba5e-179e-4e2b-89fc-8ca39512a5bc" 
                      alt="Fullproof Logo" 
                      width="200" 
                      style="display:block;"
                    />
                  </td>
                </tr>
                
                <!-- Welcome heading -->
                <tr>
                  <td style="font-size: 24px; font-weight: bold; padding: 10px 0; text-align:center">
                    Welcome to the club${firstName ? `, ${firstName}` : ""}!
                  </td>
                </tr>
                
                <!-- Intro text -->
                <tr>
                  <td style="font-size:16px; line-height:1.6; color:#333; padding: 10px;text-align:center">
                    Please click below to verify your email address.
                  </td>
                </tr>
                
                <!-- Button row -->
                <tr>
                  <td style="padding: 40px 0;">
                    <a 
                      href="${confirmationUrl}" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      style="
                       display: block;
  background-color: #007aff;
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
  padding: 12px 28px;
  border-radius: 100px;
  text-align: center;
  text-decoration: none;
  margin: 0 auto;
  max-width: 250px;
                      "
                    >
                      Verify your email
                    </a>
                  </td>
                </tr>

                <!-- Body text 1 -->
                <tr>
                  <td style="font-size:16px; line-height:1.6; color:#333; padding:10px; ">
                    Welcome to the first day of your Fullproof life! We are excited to be your trusted source for a premium selection of curated products to help you <b>feel good and live well</b>.
                  </td>
                </tr>

                <!-- Body text 2 -->
                <tr>
                  <td style="font-size:16px; line-height:1.6; color:#333; padding:10px;">
                    If you ever need anything, just send us a note via 
                    <a 
                      href="mailto:support@getfullproof.com" 
                      style="color: #007aff;"
                    >
                      support@getfullproof.com
                    </a>.
                  </td>
                </tr>

                <!-- Signature -->
                <tr>
                  <td style="font-size:16px; line-height:1.6; color:#333; padding:10px;">
                    &lt;3, The Fullproof Team
                  </td>
                </tr>

              </table>
              
              <!-- Footer (separate table to have a full-width black background) -->
              <table width="600" cellspacing="0" cellpadding="0" border="0" style="max-width:600px; width:100%; margin: 20px auto 0 auto; background-color: #000000;">
                <tr>
                  <td align="left" style="padding:20px;">
                    <!-- Footer text -->
                    <p style="font-size:12px; line-height:1.6; color:#ffffff; margin:0; padding:0;">
                      ©2025 Fullproof, Inc. or its affiliates. Fullproof and all related marks are trademarks of Fullproof, Inc. or its affiliates.
                      <br />
                      By creating an account, you also agree to Fullproof’s 
                      <a 
                        href="https://getfullproof.com/terms" 
                        style="color: #ffffff; text-decoration: underline;"
                        target="_blank"
                      >
                        Terms of Service
                      </a> 
                      and 
                      <a 
                        href="https://getfullproof.com/privacy" 
                        style="color: #ffffff; text-decoration: underline;"
                        target="_blank"
                      >
                        Privacy Policy
                      </a>.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td align="left" style="padding: 20px;">
                    <img 
                      src="https://firebasestorage.googleapis.com/v0/b/fullproof-app.firebasestorage.app/o/Logos%2Ffullproof_logo_white.png?alt=media&token=3182d97d-add6-40ed-8790-da221c9cb2af" 
                      alt="Fullproof Footer Logo"
                      style="width:120px; display:block;"
                    />
                  </td>
                </tr>
              </table>
              
            </td>
          </tr>
        </table>
      </body>
      </html>
    `,
    text: `
      Welcome to the club, ${firstName}!
      Please verify your email by visiting the following link:
      ${confirmationUrl}

      Welcome to the first day of your Fullproof life! We are excited to be your trusted source for a premium selection of curated products.

      If you ever need anything, just send us a note via support@getfullproof.com.

      <3, The Fullproof Team

      ©2025 Fullproof, Inc. or its affiliates.
      By creating an account, you agree to Fullproof’s Terms of Service and Privacy Policy.
    `,
    subject: "Confirm Your Account",
    from: "no-reply@getfullproof.com",
  };

  try {
    const docRef = await addDoc(collection(firestore, "Messages/Mail/DataBase"), {
      message,
      email,
      to: [email],
    });
    console.log("Confirmation email added successfully, ID:", docRef.id);
  } catch (error) {
    console.error("Error adding confirmation email to Firestore:", error);
  }
};

export default sendConfirmationEmail;
